<template>
  <div class="page well-page">
    <h2 class="page-title">泉井管理</h2>
    <div class="filter-card">
      <el-form :model="query" size="small" label-width="68px" class="filter-form">
        <el-row :gutter="12">
          <el-col :xl="5" :lg="6" :md="8" :sm="12" :xs="24"><el-form-item label="泉井名称"><el-input v-model="query.name" placeholder="搜索名称" clearable /></el-form-item></el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="审核状态"><el-select v-model="query.reviewStatus" clearable placeholder="全部"><el-option label="待审核" :value="0" /><el-option label="审核中" :value="1" /><el-option label="已通过" :value="2" /><el-option label="未通过" :value="3" /></el-select></el-form-item>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="24"><el-form-item label="类型"><el-select v-model="query.wellType" clearable placeholder="全部"><el-option label="泉" :value="1" /><el-option label="井" :value="2" /></el-select></el-form-item></el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24"><el-form-item label="水位"><el-select v-model="query.waterLevel" clearable placeholder="全部"><el-option-group label="泉"><el-option label="丰泉" :value="1" /><el-option label="平泉" :value="2" /><el-option label="枯泉" :value="3" /><el-option label="间歇泉" :value="4" /></el-option-group><el-option-group label="井"><el-option label="满井" :value="11" /><el-option label="常井" :value="12" /><el-option label="浅井" :value="13" /><el-option label="干井" :value="14" /></el-option-group></el-select></el-form-item></el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24"><el-form-item label="使用频率"><el-select v-model="query.useFrequency" clearable placeholder="全部"><el-option label="高频公用" :value="1" /><el-option label="中频常用" :value="2" /><el-option label="低频小众" :value="3" /><el-option label="闲置少用" :value="4" /></el-select></el-form-item></el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="24"><el-form-item label="显示状态"><el-select v-model="query.displayStatus" clearable placeholder="全部"><el-option label="显示" :value="1" /><el-option label="隐藏" :value="2" /></el-select></el-form-item></el-col>
          <el-col :xl="5" :lg="6" :md="8" :sm="12" :xs="24"><el-form-item label="地址"><el-input v-model="query.addressKeyword" placeholder="省/市/区县/详细地址" clearable /></el-form-item></el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24"><el-form-item label="上报人"><el-input v-model="query.reporterKeyword" placeholder="姓名/电话" clearable /></el-form-item></el-col>
          <el-col :xl="8" :lg="10" :md="12" :sm="24" :xs="24">
            <el-form-item label="上报时间"><el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始" end-placeholder="结束" clearable /></el-form-item>
          </el-col>
          <el-col :xl="4" :lg="8" :md="12" :sm="24" :xs="24"><el-form-item class="filter-actions"><el-button type="primary" @click="handleSearch">查询</el-button><el-button @click="handleReset">重置</el-button></el-form-item></el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-card">
      <div class="table-toolbar"><el-button type="primary" size="small" @click="openCreate">新增</el-button><el-button size="small" @click="exportList">导出</el-button></div>
      <el-table :data="tableData" v-loading="loading" border>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column label="封面" width="90"><template slot-scope="scope"><el-image class="cover" :src="resolveImageUrl(scope.row.coverImg)" fit="cover" /></template></el-table-column>
        <el-table-column prop="name" label="泉井名称" min-width="150" />
        <el-table-column label="类型" width="80"><template slot-scope="scope"><el-tag>{{ wellTypeText(scope.row.wellType) }}</el-tag></template></el-table-column>
        <el-table-column label="水位" width="90"><template slot-scope="scope"><el-tag type="success">{{ scope.row.waterLevelLabel }}</el-tag></template></el-table-column>
        <el-table-column prop="useFrequencyText" label="使用频率" width="120" />
        <el-table-column prop="address" label="详细地址" min-width="220" show-overflow-tooltip />
        <el-table-column label="上报人" min-width="160">
          <template slot-scope="scope">
            <div class="user-cell"><el-avatar :size="36" :src="scope.row.reporterAvatar" icon="el-icon-user-solid" /><div>
              <div class="main-text">{{ scope.row.reporterName || scope.row.reporterNickname || '-' }}</div>
              <div class="sub-text">{{ scope.row.contact || '-' }}</div>
            </div></div>
          </template>
        </el-table-column>
        <el-table-column label="上报时间" width="170"><template slot-scope="scope">{{ formatDateTime(scope.row.createdAt) }}</template></el-table-column>
        <el-table-column label="审核状态" width="110"><template slot-scope="scope"><el-tag :type="reviewType(scope.row.reviewStatus)">{{ reviewText(scope.row.reviewStatus) }}</el-tag></template></el-table-column>
        <el-table-column label="显示状态" width="100"><template slot-scope="scope"><el-tag :type="displayType(scope.row.shelfStatus)">{{ displayText(scope.row.shelfStatus) }}</el-tag></template></el-table-column>
        <el-table-column label="操作" width="210" fixed="right">
          <template slot-scope="scope">
            <div class="action-bar">
              <span class="action-text report" @click="openReports(scope.row)">检测报告</span>
              <span class="action-text view" @click="openView(scope.row)">查看</span>
              <span class="action-text edit" @click="openEdit(scope.row)">修改</span>
              <span v-if="scope.row.reviewStatus !== 2" class="action-text audit" @click="openAudit(scope.row)">审核</span>
              <span class="action-text delete" @click="handleDelete(scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next, total" :total="total" :current-page.sync="query.pageNum" :page-size="query.pageSize" @current-change="loadData" />
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="800px" top="4vh" :close-on-click-modal="false">
      <template v-if="dialogMode === 'view' && detail">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="泉井名称">{{ detail.name }}</el-descriptions-item>
          <el-descriptions-item label="类型">{{ wellTypeText(detail.wellType) }}</el-descriptions-item>
          <el-descriptions-item label="水位">{{ detail.waterLevelLabel || detail.waterLevel }}</el-descriptions-item>
          <el-descriptions-item label="使用频率">{{ detail.useFrequencyText || detail.useFrequency }}</el-descriptions-item>
          <el-descriptions-item label="省份">{{ detail.province }}</el-descriptions-item>
          <el-descriptions-item label="城市">{{ detail.city }}</el-descriptions-item>
          <el-descriptions-item label="区县">{{ detail.district }}</el-descriptions-item>
          <el-descriptions-item label="经纬度">{{ detail.longitude }}, {{ detail.latitude }}</el-descriptions-item>
          <el-descriptions-item label="详细地址" :span="2">{{ detail.address }}</el-descriptions-item>
          <el-descriptions-item label="上报人">{{ detail.reporterName || detail.reporterNickname }}</el-descriptions-item>
          <el-descriptions-item label="联系方式">{{ detail.contact }}</el-descriptions-item>
          <el-descriptions-item label="审核状态"><el-tag :type="reviewType(detail.reviewStatus)">{{ reviewText(detail.reviewStatus) }}</el-tag></el-descriptions-item>
          <el-descriptions-item label="显示状态"><el-tag :type="displayType(detail.shelfStatus)">{{ displayText(detail.shelfStatus) }}</el-tag></el-descriptions-item>
          <el-descriptions-item label="简介描述" :span="2">{{ detail.description || '暂无' }}</el-descriptions-item>
        </el-descriptions>
        <div class="section-title">环境标签</div>
        <template v-if="envTags && envTags.length">
          <el-tag v-for="tag in envTags" :key="tag.name || tag" class="env-tag" size="small">{{ tag.name || tag }}</el-tag>
        </template>
        <span v-else class="empty-tip">暂无</span>
        <div class="section-title">泉井图片</div>
        <template v-if="images && images.length">
          <el-image v-for="img in images" :key="img" class="photo" :src="resolveImageUrl(img)" :preview-src-list="resolveImageList(images)" fit="cover" />
        </template>
        <span v-else class="empty-tip">暂无图片</span>
      </template>

      <el-form v-if="dialogMode === 'create' || dialogMode === 'edit'" ref="editForm" :model="editForm" :rules="editRules" label-width="90px" class="edit-form">
        <el-row :gutter="16">
          <el-col :span="12"><el-form-item label="泉井名称" prop="name"><el-input v-model="editForm.name" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="类型" prop="wellType"><el-select v-model="editForm.wellType" style="width:100%" @change="editForm.waterLevel=undefined"><el-option label="泉" :value="1" /><el-option label="井" :value="2" /></el-select></el-form-item></el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="8">
            <el-form-item label="省份">
              <el-input v-model="editForm.province" placeholder="请输入省份" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="城市">
              <el-input v-model="editForm.city" placeholder="请输入城市" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="区县">
              <el-input v-model="editForm.district" placeholder="请输入区县" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="详细地址"><el-input v-model="editForm.address" /></el-form-item>
        <el-row :gutter="16">
          <el-col :span="12"><el-form-item label="经度" prop="longitude"><el-input v-model="editForm.longitude" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="纬度" prop="latitude"><el-input v-model="editForm.latitude" /></el-form-item></el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="水位/水量" prop="waterLevel">
              <el-select v-model="editForm.waterLevel" style="width:100%">
                <template v-if="editForm.wellType === 1">
                  <el-option label="丰水泉（常年涌水充沛）" :value="1" />
                  <el-option label="平水泉（出水量均衡）" :value="2" />
                  <el-option label="枯水泉（旱季几乎断流）" :value="3" />
                  <el-option label="间歇泉（涌水具有周期性）" :value="4" />
                </template>
                <template v-else>
                  <el-option label="满井（地下水位高，取水充足）" :value="11" />
                  <el-option label="常规井（水位平稳，可满足日常）" :value="12" />
                  <el-option label="浅枯井（水位偏低，旱旱取水难）" :value="13" />
                  <el-option label="干浸井（地下水枯竭，无水可用）" :value="14" />
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="使用频率" prop="useFrequency">
              <el-select v-model="editForm.useFrequency" style="width:100%">
                <el-option label="高频公用（50人/日以上）" :value="1" />
                <el-option label="中频常用（10–50人/日）" :value="2" />
                <el-option label="低频小众（10人/日以内）" :value="3" />
                <el-option label="闲置少用（极少有人打水）" :value="4" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="简介描述"><el-input v-model="editForm.description" type="textarea" :rows="3" /></el-form-item>
        <el-form-item label="环境标签">
          <el-checkbox-group v-model="editForm.envTagsArr" class="env-checkbox-group">
            <el-checkbox v-for="tag in ENV_TAG_OPTIONS" :key="tag" :label="tag">{{ tag }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-row :gutter="16">
          <el-col :span="12"><el-form-item label="上报人"><el-input v-model="editForm.reporterName" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="联系方式"><el-input v-model="editForm.contact" /></el-form-item></el-col>
        </el-row>
        <el-form-item label="泉井图片">
          <div class="img-upload-list">
            <div v-for="(img, idx) in editForm.images" :key="idx" class="img-upload-item">
              <el-image :src="resolveImageUrl(img)" fit="cover" class="img-thumb" :preview-src-list="[resolveImageUrl(img)]" />
              <span class="img-delete" @click="removeEditImage(idx)">×</span>
            </div>
            <label v-if="!editForm.images || editForm.images.length < 9" :class="['img-upload-add', uploading ? 'disabled' : '']">
              <input type="file" accept="image/*" multiple style="display:none" @change="handleImageFileChange" :disabled="uploading" />
              {{ uploading ? '上传中…' : '+ 添加图片' }}
            </label>
          </div>
        </el-form-item>
        <el-form-item label="显示状态">
          <el-radio-group v-model="editForm.shelfStatus">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="2">隐藏</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <template v-if="dialogMode === 'audit'">
        <el-descriptions v-if="detail" :column="2" border size="small" style="margin-bottom:16px">
          <el-descriptions-item label="泉井名称">{{ detail.name }}</el-descriptions-item>
          <el-descriptions-item label="上报人">{{ detail.reporterName || detail.reporterNickname }}</el-descriptions-item>
          <el-descriptions-item label="详细地址" :span="2">{{ detail.address }}</el-descriptions-item>
        </el-descriptions>
        <el-form ref="auditForm" :model="auditForm" :rules="rules" label-width="100px" class="audit-form">
          <el-form-item label="审核结论" prop="reviewStatus">
            <el-radio-group v-model="auditForm.reviewStatus">
              <el-radio :label="2">通过</el-radio>
              <el-radio :label="3">不通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="auditForm.reviewStatus === 3" label="拒绝原因" prop="rejectReason">
            <el-input v-model="auditForm.rejectReason" type="textarea" :rows="3" placeholder="请填写拒绝原因" />
          </el-form-item>
        </el-form>
      </template>

      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button v-if="dialogMode === 'audit'" type="primary" @click="submitAudit">提交审核</el-button>
        <el-button v-if="dialogMode === 'create' || dialogMode === 'edit'" type="primary" @click="submitEdit">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog class="report-dialog" :title="'检测报告 - ' + reportWellName" :visible.sync="reportDialogVisible" width="1060px" top="3vh" :close-on-click-modal="false">
      <el-form v-if="reportMode !== 'list'" :model="reportForm" label-width="90px">
        <el-form-item label="检测时间"><el-date-picker v-model="reportForm.testDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择检测时间" style="width:100%" /></el-form-item>
        <el-form-item label="检测机构"><el-input v-model="reportForm.testOrg" placeholder="请输入检测机构名称" /></el-form-item>
        <el-form-item label="检测结果">
          <el-radio-group v-model="reportForm.testResult">
            <el-radio :label="1">可饮用</el-radio>
            <el-radio :label="2">不可饮用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="报告文件">
          <el-upload
            action="#"
            :show-file-list="false"
            :before-upload="beforeReportUpload"
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            multiple
            :disabled="reportUploading"
          >
            <el-button size="small" type="primary" :loading="reportUploading" icon="el-icon-paperclip">选择附件</el-button>
          </el-upload>
          <div v-if="reportForm.reportFiles.length" class="attachment-list">
            <div v-for="(f, idx) in reportForm.reportFiles" :key="idx" class="attachment-item">
              <i class="el-icon-paperclip"></i>
              <span class="attachment-name" :title="f.name">{{ f.name }}</span>
              <span class="attachment-del" @click="reportForm.reportFiles.splice(idx, 1)">×</span>
            </div>
          </div>
          <div class="report-file-tip">支持 pdf、doc、docx、jpg、png 格式，最多9个文件</div>
        </el-form-item>
      </el-form>

      <template v-else>
        <div class="report-toolbar"><el-button type="primary" size="small" @click="openReportForm()">新增报告</el-button></div>
        <el-table :data="reportList" v-loading="reportLoading" border size="small">
          <el-table-column prop="id" label="ID" width="60" />
          <el-table-column label="检测时间" width="110"><template slot-scope="scope">{{ scope.row.testDate || '-' }}</template></el-table-column>
          <el-table-column prop="testOrg" label="检测机构" min-width="150" show-overflow-tooltip />
          <el-table-column label="检测结果" width="90"><template slot-scope="scope"><el-tag :type="scope.row.testResult === 1 ? 'success' : 'danger'" size="small">{{ scope.row.testResult === 1 ? '可饮用' : '不可饮用' }}</el-tag></template></el-table-column>
          <el-table-column label="上传者" min-width="150">
            <template slot-scope="scope">
              <div v-if="scope.row.uploaderType === 2" class="uploader-cell">
                <span class="uploader-badge">后台</span>
                <span class="uploader-name">{{ scope.row.uploaderName || '未知' }}</span>
              </div>
              <div v-else class="uploader-cell">
                <el-image v-if="scope.row.uploaderAvatar" :src="resolveImageUrl(scope.row.uploaderAvatar)" class="uploader-avatar" />
                <span class="uploader-name">{{ scope.row.uploaderName || '小程序用户' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="报告文件" min-width="180">
            <template slot-scope="scope">
              <div class="report-file-list">
                <a v-for="(url, i) in splitReportFiles(scope.row.reportFile)" :key="i" class="attachment-link" :href="resolveImageUrl(url)" target="_blank" rel="noopener">
                  <i class="el-icon-paperclip"></i><span class="attachment-name">{{ fileNameFromUrl(url) }}</span>
                </a>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="上传时间" width="160"><template slot-scope="scope">{{ formatDateTime(scope.row.createdAt) }}</template></el-table-column>
          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <span class="action-text edit" @click="openReportForm(scope.row)">编辑</span>
              <span class="action-text delete" style="margin-left:12px" @click="handleDeleteReport(scope.row)">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <span slot="footer">
        <el-button @click="reportMode === 'list' ? (reportDialogVisible = false) : (reportMode = 'list')">{{ reportMode === 'list' ? '关闭' : '返回列表' }}</el-button>
        <el-button v-if="reportMode !== 'list'" type="primary" @click="submitReportForm">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { fetchWells, fetchWellDetail, reportWell, auditWell, updateWell, updateWellShelf, deleteWell, uploadImage, uploadFile, fetchTestReports, addTestReport, updateTestReport, deleteTestReport } from '@/api'
import { resolveImageUrl, resolveImageList, unresolveImageList } from '@/utils/media'

const REGION_DATA = {
  '湖南省': {
    '长沙市': ['芯稗区','天心区','岳麓区','雨花区','浏阳区','开福区','宁乡县','望城县','长沙县'],
    '株洲市': ['荷塘区','芦淞区','石峰区','天元区','清水区','正塞区'],
    '岞阳市': ['嶫城区','魔腾区','嶫丟区','云溪区','鲁山县','平江县','岞阳县'],
    '邵阳市': ['双清区','源江区','大祥区','北塔区','洞口县','新宁县','邵东县'],
    '怀化市': ['鹤城区','中方县','邵阳县','新晃县','芷丟县'],
    '尸底市': ['尸城区','冷水滩区','诠市','津市','江华县','邵阳县']
  },
  '广东省': {
    '广州市': ['天河区','海珠区','越秀区','番禺区','花都区','白云区','黄埔区','萐岗区','增城区','南沙区'],
    '深圳市': ['福田区','罗湖区','南山区','盐田区','宝安区','龙华区','光明新区'],
    '东莞市': ['东城区','南城区','万江区','石情镇','虹怪镇']
  },
  '北京市': { '北京市': ['东城区','西城区','朝阳区','丰台区','石景山区','海淀区','房山区','通州区','顺义区','大兴区','昌平区','平谷区','怀柔区','密云区','延慶区'] },
  '上海市': { '上海市': ['黄浦区','卢湾区','静安区','徐汇区','长宁区','普陀区','虞汇区','闸北区','松江区','金山区','奉贤区','青浦区','嘉定区','宝山区'] },
  '浙江省': {
    '杭州市': ['上城区','下城区','拱墅区','滨江区','余杭区','萨子区','富阳区','临安区','桐庐县','淳安县'],
    '宁波市': ['海恕区','江北区','镇海区','鄂州区','奥江区','余姚区','宁海县']
  }
}

export default {
  data() {
    return {
      ENV_TAG_OPTIONS: ['厕所','农田','养殖','垃圾点','排污沟','公路','民居','隔离围墙'],
      loading: false, uploading: false,
      tableData: [], total: 0, dateRange: [],
      query: { pageNum:1, pageSize:10, name:'', reviewStatus:undefined, wellType:undefined, waterLevel:undefined, useFrequency:undefined, addressKeyword:'', reporterKeyword:'', displayStatus:undefined },
      dialogVisible: false, dialogMode: 'view', detail: null, editForm: {},
      auditForm: { id:null, reviewStatus:2, rejectReason:'' },
      reportDialogVisible: false, reportMode: 'list', reportWellId: null, reportWellName: '',
      reportList: [], reportLoading: false, reportUploading: false,
      reportForm: { id: null, testDate: '', testOrg: '', testResult: 1, reportFiles: [] },
      rules: { reviewStatus:[{required:true,message:'请选择审核结论',trigger:'change'}], rejectReason:[{required:true,message:'请填写拒绝原因',trigger:'blur'}] },
      editRules: { name:[{required:true,message:'请输入泉井名称',trigger:'blur'}], longitude:[{required:true,message:'请输入经度',trigger:'blur'}], latitude:[{required:true,message:'请输入纬度',trigger:'blur'}], wellType:[{required:true,message:'请选择类型',trigger:'change'}], waterLevel:[{required:true,message:'请选择水位',trigger:'change'}], useFrequency:[{required:true,message:'请选择使用频率',trigger:'change'}] }
    }
  },
  computed: {
    envTags() { return this.detail && this.detail.envTags ? this.detail.envTags.filter(t => t.selected) : [] },
    images() { return this.detail && this.detail.images ? this.detail.images : [] },
    dialogTitle() { return this.dialogMode==='audit'?'泉井审核':this.dialogMode==='create'?'新增泉井':this.dialogMode==='edit'?'修改泉井':'泉井详情' }
  },
  created() { this.loadData() },
  methods: {
    resolveImageUrl, resolveImageList, unresolveImageList,
    async loadData() {
      this.loading = true
      try {
        const params = { ...this.query }
        if (this.dateRange && this.dateRange.length === 2) { params.startTime = this.dateRange[0]; params.endTime = this.dateRange[1] }
        Object.keys(params).forEach(k => { if (params[k]===''||params[k]===null||params[k]===undefined) delete params[k] })
        const res = await fetchWells(params)
        this.tableData = res.records || []; this.total = res.total || 0
      } finally { this.loading = false }
    },
    handleSearch() { this.query.pageNum=1; this.loadData() },
    handleReset() { this.dateRange=[]; this.query={pageNum:1,pageSize:10,name:'',reviewStatus:undefined,wellType:undefined,waterLevel:undefined,useFrequency:undefined,addressKeyword:'',reporterKeyword:'',displayStatus:undefined}; this.loadData() },
    openCreate() {
      this.dialogMode='create'; this.detail=null
      this.editForm={name:'',longitude:'',latitude:'',address:'',province:'',city:'',district:'',wellType:1,waterLevel:undefined,useFrequency:undefined,description:'',envTags:'',envTagsArr:[],images:[],reporterName:'',contact:'',shelfStatus:1}
      this.dialogVisible=true
    },
    async openView(row) {
      try { this.dialogMode='view'; this.detail=await fetchWellDetail(row.id); this.dialogVisible=true }
      catch(e) { this.$message.error('加载详情失败，请稍候重试') }
    },
    async openEdit(row) {
      try {
        const detail = await fetchWellDetail(row.id)
        this.dialogMode = 'edit'
        const raw = detail.envTags
        const arr = Array.isArray(raw)
          ? raw.filter(t => t.selected).map(t => t.name)
          : (typeof raw === 'string' && raw ? raw.split(',').map(s => s.trim()).filter(Boolean) : [])
        this.editForm = {
          ...detail, id: row.id,
          envTags: arr.join(','), envTagsArr: arr,
          images: unresolveImageList(detail.images || []),
          waterLevel: Number(detail.waterLevel) || undefined,
          useFrequency: Number(detail.useFrequency) || undefined,
          shelfStatus: Number(detail.shelfStatus) || 1
        }
        this.dialogVisible = true
      } catch(e) { this.$message.error('加载详情失败，请稍候重试') }
    },
    async openAudit(row) {
      try { this.dialogMode='audit'; this.auditForm={id:row.id,reviewStatus:row.reviewStatus===3?3:2,rejectReason:row.rejectReason||''}; this.detail=await fetchWellDetail(row.id); this.dialogVisible=true }
      catch(e) { this.$message.error('加载详情失败，请稍候重试') }
    },
    submitAudit() {
      this.$refs.auditForm.validate(async v => {
        if (!v) return
        try { await auditWell(this.auditForm); this.$message.success('审核已提交'); this.dialogVisible=false; this.loadData() }
        catch(e) {}
      })
    },
    submitEdit() {
      this.$refs.editForm.validate(async v => {
        if (!v) return
        try {
          if (this.dialogMode === 'create') {
            const p = { ...this.editForm, envTags: (this.editForm.envTagsArr || []).join(',') }
            if (!p.images || !p.images.length) delete p.images
            delete p.shelfStatus
            const id = await reportWell(p)
            if (Number(this.editForm.shelfStatus || 1) === 2) await updateWellShelf({ id, shelfStatus: 2, reason: '管理员操作' })
          } else {
            await updateWell({ ...this.editForm, envTags: (this.editForm.envTagsArr || []).join(','), waterLevel: Number(this.editForm.waterLevel), useFrequency: Number(this.editForm.useFrequency) })
            await updateWellShelf({ id: this.editForm.id, shelfStatus: this.editForm.shelfStatus || 1, reason: this.editForm.shelfStatus === 2 ? '管理员操作' : '' })
          }
          this.$message.success(this.dialogMode === 'create' ? '新增成功' : '修改成功')
          this.dialogVisible = false; this.loadData()
        } catch(e) {}
      })
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除泉井「' + row.name + '」？', '删除确认', { confirmButtonText: '确认删除', cancelButtonText: '取消', type: 'warning' })
        await deleteWell(row.id); this.$message.success('泉井已删除'); this.loadData()
      } catch(e) {}
    },
    removeEditImage(idx) { this.editForm.images = this.editForm.images.filter((_, i) => i !== idx) },
    async openReports(row) {
      this.reportWellId = row.id
      this.reportWellName = row.name
      this.reportMode = 'list'
      this.reportDialogVisible = true
      await this.loadReports()
    },
    async loadReports() {
      this.reportLoading = true
      try {
        const res = await fetchTestReports({ wellId: this.reportWellId })
        this.reportList = res || []
      } catch(e) { this.$message.error('加载检测报告失败') }
      finally { this.reportLoading = false }
    },
    openReportForm(row) {
      if (row) {
        this.reportForm = { id: row.id, testDate: row.testDate, testOrg: row.testOrg, testResult: row.testResult, reportFiles: this.splitReportFiles(row.reportFile).map(url => ({ name: this.fileNameFromUrl(url), url })) }
      } else {
        this.reportForm = { id: null, testDate: '', testOrg: '', testResult: 1, reportFiles: [] }
      }
      this.reportMode = 'edit'
    },
    fileNameFromUrl(url) {
      if (!url) return '附件'
      const name = String(url).split('/').pop().split('?')[0]
      return name || '附件'
    },
    beforeReportUpload(file) {
      if (this.reportForm.reportFiles.length >= 9) { this.$message.warning('最多上传9个文件'); return false }
      this.reportUploading = true
      uploadFile(file).then(url => {
        if (url) this.reportForm.reportFiles.push({ name: file.name, url })
      }).catch(() => { this.$message.error('文件上传失败') })
        .finally(() => { this.reportUploading = false })
      return false
    },
    async submitReportForm() {
      if (!this.reportForm.testDate) { this.$message.warning('请选择检测时间'); return }
      if (!this.reportForm.testOrg) { this.$message.warning('请输入检测机构'); return }
      if (!this.reportForm.reportFiles.length) { this.$message.warning('请上传报告文件'); return }
      const payload = { testDate: this.reportForm.testDate, testOrg: this.reportForm.testOrg, testResult: this.reportForm.testResult, reportFile: this.reportForm.reportFiles.map(f => f.url).join(',') }
      try {
        if (this.reportForm.id) { await updateTestReport({ id: this.reportForm.id, ...payload }) }
        else { await addTestReport({ wellId: this.reportWellId, ...payload }) }
        this.$message.success('保存成功')
        this.reportMode = 'list'
        await this.loadReports()
      } catch(e) {}
    },
    async handleDeleteReport(row) {
      try {
        await this.$confirm('确认删除该检测报告？', '删除确认', { type: 'warning' })
        await deleteTestReport(row.id)
        this.$message.success('已删除')
        this.loadReports()
      } catch(e) {}
    },
    splitReportFiles(str) {
      if (!str) return []
      return String(str).split(',').map(s => s.trim()).filter(Boolean)
    },
    async handleImageFileChange(e) {
      const files = Array.from(e.target.files); if (!files.length) return; this.uploading = true
      try { for (const f of files) { const url = await uploadImage(f); this.editForm.images = [...(this.editForm.images || []), url] } }
      catch(err) { this.$message.error('图片上传失败') }
      finally { this.uploading = false; e.target.value = '' }
    },
    exportList() {
      const h = ['序号','泉井名称','类型','水位','使用频率','详细地址','上报人','联系方式','上报时间','审核状态','显示状态']
      const r = this.tableData.map((row, i) => [i+1, row.name, this.wellTypeText(row.wellType), row.waterLevelLabel, row.useFrequencyText, row.address, row.reporterName, row.contact, this.formatDateTime(row.createdAt), this.reviewText(row.reviewStatus), this.displayText(row.shelfStatus)])
      const csv = [h, ...r].map(items => items.map(v => '"' + String(v == null ? '' : v).replace(/"/g, '""') + '"').join(',')).join('\n')
      const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a'); link.href = URL.createObjectURL(blob); link.download = '泉井列表_' + new Date().toISOString().slice(0, 10) + '.csv'; link.click(); URL.revokeObjectURL(link.href)
    },
    formatDateTime(v) { return v ? String(v).replace('T', ' ') : '-' },
    wellTypeText(v) { return v === 1 ? '泉' : v === 2 ? '井' : '未知' },
    reviewText(v) { return ['待审核','审核中','已通过','未通过'][v] || '未知' },
    reviewType(v) { return v === 2 ? 'success' : v === 3 ? 'danger' : 'warning' },
    displayText(v) { return Number(v || 1) === 1 ? '显示' : '隐藏' },
    displayType(v) { return Number(v || 1) === 1 ? 'success' : 'info' },
    statusType(c) { return c === 'green' ? 'success' : c === 'red' ? 'danger' : 'warning' }
  }
}
</script>

<style scoped>
.filter-form ::v-deep .el-row{width:100%}
.filter-form ::v-deep .el-form-item{margin-bottom:12px}
.filter-form ::v-deep .el-input,.filter-form ::v-deep .el-select,.filter-form ::v-deep .el-date-editor{width:100%}
.filter-form ::v-deep .filter-actions .el-form-item__content{display:flex;gap:8px}
.user-cell{display:flex;align-items:center;gap:10px}
.main-text{color:#333;font-weight:600;line-height:20px}
.sub-text{color:#909399;font-size:12px;line-height:18px}
.action-bar{display:flex;align-items:center;flex-wrap:wrap;gap:4px 10px}
.action-text{cursor:pointer;font-size:13px}
.action-text:hover{text-decoration:underline}
.action-text.view{color:#606266}.action-text.edit{color:#409eff}.action-text.audit{color:#2f8f5b}.action-text.delete{color:#f56c6c}.action-text.report{color:#e6a23c}
.table-toolbar{display:flex;justify-content:flex-end;gap:10px;margin-bottom:12px}
.cover{width:56px;height:56px;border-radius:8px;background:#f2f2f2}
.photo{width:96px;height:96px;border-radius:10px;margin:8px 8px 0 0}
.section-title{margin:18px 0 10px;font-weight:700;color:#123c2f}
.audit-form,.edit-form{margin-top:18px}
.edit-form ::v-deep .el-select{width:100%}
.img-upload-list{display:flex;flex-wrap:wrap;gap:10px}
.img-upload-item{position:relative;width:90px;height:90px;border-radius:6px;overflow:hidden;border:1px solid #e0e0e0}
.img-thumb{width:90px;height:90px}
.img-delete{position:absolute;top:2px;right:4px;color:#fff;background:rgba(0,0,0,.55);border-radius:50%;width:18px;height:18px;line-height:18px;text-align:center;font-size:14px;cursor:pointer}
.img-upload-add{display:flex;align-items:center;justify-content:center;width:90px;height:90px;border:1px dashed #ccc;border-radius:6px;cursor:pointer;font-size:13px;color:#409eff;background:#fafafa}
.img-upload-add.disabled{opacity:.5;cursor:not-allowed}
.el-pagination{margin-top:16px;text-align:right}
.env-checkbox-group{display:flex;flex-wrap:wrap;gap:4px 16px;padding-top:4px}
.empty-tip{color:#999;font-size:13px}
.env-tag{margin:2px 4px 2px 0}
.report-dialog .el-dialog__body{max-height:72vh;overflow-y:auto}
.report-toolbar{display:flex;justify-content:flex-end;margin-bottom:12px}
.uploader-cell{display:flex;align-items:center;gap:6px}
.uploader-badge{font-size:12px;color:#909399;border:1px solid #d9d9d9;border-radius:3px;padding:0 6px;line-height:18px}
.uploader-avatar{width:24px;height:24px;border-radius:50%;background:#f2f2f2}
.uploader-name{font-size:13px;color:#333}
.report-file-list{display:flex;flex-direction:column;gap:4px}
.attachment-link{display:flex;align-items:center;gap:4px;font-size:13px;color:#409eff;text-decoration:none;max-width:260px}
.attachment-link:hover{text-decoration:underline}
.attachment-link .el-icon-paperclip{color:#909399;font-size:14px}
.attachment-link .attachment-name{flex:1;min-width:0}
.attachment-list{display:flex;flex-wrap:wrap;gap:8px;margin-top:8px}
.attachment-item{display:flex;align-items:center;gap:6px;padding:4px 10px;border:1px solid #e0e0e0;border-radius:4px;background:#fafafa;max-width:320px}
.attachment-item .el-icon-paperclip{color:#909399;font-size:14px}
.attachment-name{font-size:13px;color:#333;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.attachment-del{cursor:pointer;color:#f56c6c;font-size:16px;line-height:1}
.report-file-tip{font-size:12px;color:#999;margin-top:4px}
</style>